import React, { FC, useRef, useState } from "react";
import { Button, Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import TypeDiContainer from 'typedi';
import AuthService from "../../../services/AuthService";
import SpinnerOverlay from "../../SpinnerOverlay/SpinnerOverlay";

export const LoginForm: FC = () => {
  const [isWorking, setIsWorking] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>(null);
  const emailAddressRef = useRef<HTMLInputElement>();
  const passwordRef = useRef<HTMLInputElement>();

  async function onLoginClicked(e: React.MouseEvent) {
    e.preventDefault();
    const email = emailAddressRef.current.value;
    const password = passwordRef.current.value;
    try {
      await TypeDiContainer.get(AuthService).login(email, password);
      location.href = '/';
    } catch (err) {
      setErrorMessage(err.message)
      setIsWorking(false);
    } finally {
    }
  }

  return (
    <Form className="mt-5">
      <h4 className="display mb-4">AG Decor IMS</h4>
      <FormGroup className="mb-3">
        <Label>Email address</Label>
        <Input disabled={isWorking} type="text" innerRef={emailAddressRef} placeholder="Email address" />
      </FormGroup>
      <FormGroup className="mb-3">
        <Label>Password</Label>
        <Input disabled={isWorking} type="password" innerRef={passwordRef} placeholder="Password" />
      </FormGroup>
      <div className="text-right mt-4">
        <Button type="submit" disabled={isWorking} color="primary" onClick={onLoginClicked}>Login</Button>
        {errorMessage &&
          <div className="text-danger">
            {errorMessage}
          </div>
        }
      </div>
      <SpinnerOverlay active={isWorking} />
    </Form>
  )
};